import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	epicTitle: {
		id: 'native-issue-table.common.issue-cells.epic-link.epic-title',
		defaultMessage: 'Click to visit',
		description: 'Epic url title - Click to visit [epic]',
	},
});
